export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-torsos-male-female-a9f34d3cc908938825335f37d9aa0e85.svg";